import type { TFunction } from 'i18next'
import type { CommandEntry } from '@/stores/commandsStore'

/**
 * Comandos que só existem na tela (sem skill no catálogo do motor). Espelham os
 * locais de `useCommandPalette`; aqui entram os que valem para todo mundo.
 * Os rótulos reaproveitam as chaves que a paleta já usa.
 */
export function comandosLocaisDaAjuda(t: TFunction): CommandEntry[] {
  return [
    {
      id: 'cronograma',
      label: t('schedule.commands.cronograma.label'),
      description: t('schedule.commands.cronograma.description'),
      prompt: '/cronograma',
      order: -1,
    },
    {
      id: 'tour',
      label: t('guidedTour.comando.label'),
      description: t('guidedTour.comando.description'),
      prompt: '/tour',
      order: -1,
    },
    {
      id: 'ajuda',
      label: t('guidedTour.ajuda.comandos.ajudaLabel'),
      description: t('guidedTour.ajuda.comandos.ajudaDescricao'),
      prompt: '/ajuda',
      order: -1,
    },
  ]
}

/** Catálogo do motor primeiro; um local nunca repete um id que o motor já trouxe. */
export function juntarComandos(catalogo: CommandEntry[], locais: CommandEntry[]): CommandEntry[] {
  const ids = new Set(catalogo.map((c) => c.id))
  return [...[...catalogo].sort((a, b) => a.order - b.order), ...locais.filter((c) => !ids.has(c.id))]
}
